

export class Incident {
    id: number;
    date_added: string; 
    time_added: string;
    time_string: TimeString;
    hour: number;
    minute: number;
    status_id: number;
    question_id: number;
    rating_id: number;
    description: string;
    location: string;
    witness: string;
    notification: string; 
    ////////////////
    type_id: number;
    driver_id: number;
    fleet_id: number;
    filename: string;
    /////
    driver: string;
    rego: string;
    type: string;
    rating: string;
    status: string;
    incidentTaskCount : number;
}
export class IncidentMobile {
    date_added: any;
    dd2: any;
    dd3: any;
    demerits: any;
    domain: any;
    driver_id: any;
    driver_name: any;
    driver_signature: any;
    fine: any;
    incident: any;
    lat: any;
    lng: any;
    loc_date: any;
    location: any;
    map: any;
    isSigned: any;
    note: any;
    notification: any;
    time_added: any;
    timeadded2: any;
    violation: any;
    witness: any;
}

export interface TimeString {
    hour: number;
    minute: number;
}

